export default __webpack_public_path__ + "static/media/services.61758f59.svg";